(function (globalObject, factory) {
  'use strict';

  var storefrontReviews = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = storefrontReviews;
  }

  if (globalObject) {
    globalObject.StorefrontReviews = storefrontReviews;
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', storefrontReviews.initialize);
    } else {
      storefrontReviews.initialize();
    }
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var SUPPORTED_GROUPS = [
    'graphic-socks',
    'graphic-underwear',
    'hex-performance',
    'womens-tops-bottoms'
  ];
  var SUPPORTED_SORTS = ['featured', 'newest', 'rating'];
  var DEFAULT_LIMIT = 20;
  var DEFAULT_SORT = 'newest';
  var cache = typeof window !== 'undefined'
    ? (window.__storefrontReviewsCache = window.__storefrontReviewsCache || {})
    : {};

  function normalize(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  function compactValues(values) {
    return values.map(normalize).filter(function (value) {
      return value.length > 0;
    });
  }

  function includesAny(values, candidates) {
    return candidates.some(function (candidate) {
      return values.indexOf(candidate) !== -1;
    });
  }

  function containsAny(value, candidates) {
    var normalizedValue = normalize(value);
    return candidates.some(function (candidate) {
      return normalizedValue.indexOf(candidate) !== -1;
    });
  }

  function supportedGroup(value) {
    var group = normalize(value);
    return SUPPORTED_GROUPS.indexOf(group) !== -1 ? group : '';
  }

  function supportedSort(value) {
    var sort = normalize(value);
    return SUPPORTED_SORTS.indexOf(sort) !== -1 ? sort : DEFAULT_SORT;
  }

  function normalizedOffset(value) {
    var offset = Number(value);
    return Number.isFinite(offset) && offset >= 0 ? Math.floor(offset) : 0;
  }

  function selectedVariant(product, variantId) {
    var variants = Array.isArray(product.variants) ? product.variants : [];
    var wantedId = String(variantId == null ? product.selectedVariantId : variantId);

    return variants.filter(function (variant) {
      return String(variant.id) === wantedId;
    })[0] || variants[0] || {};
  }

  function classifyProduct(product, variantId) {
    product = product || {};

    var variant = selectedVariant(product, variantId);
    var override = supportedGroup(variant.reviewGroup) || supportedGroup(product.reviewGroup);
    var tags = compactValues(Array.isArray(product.tags) ? product.tags : []);
    var type = normalize(product.type);
    var templateSuffix = normalize(product.templateSuffix);
    var style = compactValues([variant.style, product.style]).join(' ');
    var format = compactValues([variant.format, product.format]).join(' ');
    var sku = String(variant.sku || '').toUpperCase();
    var structuredText = [style, format].join(' ');

    if (override) {
      return { group: override, reason: 'explicit review-group metafield' };
    }

    if (
      includesAny(tags, ['perppweb', 'hexperform', 'hex performance', 'hex-performance']) ||
      containsAny(structuredText, ['hex performance', 'hex-performance']) ||
      /(?:^|-)HEX(?:-|$)/.test(sku) ||
      templateSuffix === 'performance'
    ) {
      return { group: 'hex-performance', reason: 'Hex tag, format, SKU, or template' };
    }

    if (
      includesAny(tags, ['bra', 'boy shorts', 'boyshorts', "women's underwear", 'womens underwear', 'womenslife']) ||
      containsAny(structuredText, ['sports bra', 'boy shorts', 'boyshorts']) ||
      /(?:^|-)(?:WBRA|WBSH)(?:-|$)/.test(sku)
    ) {
      return { group: 'womens-tops-bottoms', reason: 'women\'s product tag, format, or SKU' };
    }

    if (
      includesAny(tags, ['boxer briefs', 'boxer brief', 'mens boxers', "men's underwear", 'mens underwear']) ||
      containsAny(structuredText, ['boxer brief', 'mens underwear', "men's underwear"]) ||
      /(?:^|-)MBB(?:-|$)/.test(sku) ||
      type === 'boxer briefs'
    ) {
      return { group: 'graphic-underwear', reason: 'men\'s underwear tag, type, format, or SKU' };
    }

    var excludedSockTags = includesAny(tags, [
      'hoppweb',
      'hyperoptic',
      'knppweb',
      'knit',
      'knitted',
      'custom socks',
      'custom sock'
    ]);
    var graphicSockSignal = includesAny(tags, ['grppweb', 'graphic', 'graphic socks', 'lifestyle', 'socks']) ||
      containsAny(style, ['graphic']) ||
      templateSuffix === 'graphic';

    if (type === 'socks' && graphicSockSignal && !excludedSockTags) {
      return { group: 'graphic-socks', reason: 'graphic sock type with structured catalog signal' };
    }

    return {
      group: '',
      reason: 'no supported group matched product type, tags, metafields, template, or variant SKU'
    };
  }

  function buildApiUrl(apiUrl, group, sort, offset) {
    var url = new URL(apiUrl);
    var validGroup = supportedGroup(group);

    if (url.protocol !== 'https:') {
      throw new Error('Reviews API URL must use HTTPS.');
    }
    if (!validGroup) {
      throw new Error('Unsupported review group.');
    }

    url.searchParams.set('group', validGroup);
    url.searchParams.set('limit', String(DEFAULT_LIMIT));
    url.searchParams.set('offset', String(normalizedOffset(offset)));
    url.searchParams.set('sort', supportedSort(sort));
    return url.toString();
  }

  function validateResponse(payload, expectedGroup) {
    if (
      !payload ||
      payload.success !== true ||
      !payload.group ||
      supportedGroup(payload.group.key) !== supportedGroup(expectedGroup) ||
      !Array.isArray(payload.reviews)
    ) {
      throw new Error('Invalid Reviews API response.');
    }
    return payload;
  }

  function loadReviews(group, apiUrl, fetchImplementation, responseCache, sort, offset) {
    var activeCache = responseCache || cache;
    var fetcher = fetchImplementation || (typeof window !== 'undefined' && window.fetch);
    var requestUrl;
    try {
      requestUrl = buildApiUrl(apiUrl, group, sort, offset);
    } catch (error) {
      return Promise.reject(error);
    }
    var cacheKey = requestUrl;

    if (activeCache[cacheKey]) {
      return activeCache[cacheKey];
    }

    if (typeof fetcher !== 'function') {
      return Promise.reject(new Error('Fetch is unavailable.'));
    }

    activeCache[cacheKey] = Promise.resolve().then(function () {
      if (typeof window !== 'undefined' && window.console && typeof window.console.info === 'function') {
        window.console.info('[StorefrontReviews] API request', {
          group: group,
          sort: supportedSort(sort),
          offset: normalizedOffset(offset),
          url: requestUrl
        });
      }
      return fetcher(requestUrl, {
        method: 'GET',
        headers: { Accept: 'application/json' },
        credentials: 'omit'
      });
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Reviews API returned HTTP ' + response.status + '.');
      }
      return response.json();
    }).then(function (payload) {
      if (typeof window !== 'undefined' && window.console && typeof window.console.info === 'function') {
        window.console.info('[StorefrontReviews] API response', payload);
      }
      return validateResponse(payload, group);
    }).catch(function (error) {
      delete activeCache[cacheKey];
      if (typeof window !== 'undefined' && window.console && typeof window.console.error === 'function') {
        window.console.error('[StorefrontReviews] API error', error);
      }
      throw error;
    });

    return activeCache[cacheKey];
  }

  function resolveReviewState(status, payload) {
    if (status === 'loading') return 'loading';
    if (status === 'success' && payload && Array.isArray(payload.reviews) && payload.reviews.length > 0) {
      return 'ready';
    }
    return 'hidden';
  }

  function shouldFetchGroup(activeGroup, nextGroup) {
    return Boolean(nextGroup) && activeGroup !== nextGroup;
  }

  function numberOrZero(value) {
    var number = Number(value);
    return Number.isFinite(number) && number >= 0 ? number : 0;
  }

  function appendUniqueReviews(state, reviews) {
    var added = 0;
    (Array.isArray(reviews) ? reviews : []).forEach(function (review) {
      var reviewId = review && review.id != null ? String(review.id) : '';
      if (reviewId && state.seenReviewIds[reviewId]) return;
      if (reviewId) state.seenReviewIds[reviewId] = true;
      state.allReviews.push(review);
      added += 1;
    });
    return added;
  }

  function appendReviewPage(state, payload, requestedOffset) {
    var reviews = payload && Array.isArray(payload.reviews) ? payload.reviews : [];
    var pagination = payload && payload.pagination ? payload.pagination : {};
    var returned = Number(pagination.returned);
    var responseOffset = normalizedOffset(pagination.offset);
    var baseOffset = Math.max(normalizedOffset(requestedOffset), responseOffset);
    var total = numberOrZero(payload && payload.summary && payload.summary.total);
    var added = appendUniqueReviews(state, reviews);

    if (!Number.isFinite(returned) || returned < 0 || (returned === 0 && reviews.length > 0)) {
      returned = reviews.length;
    }

    state.nextOffset = baseOffset + Math.floor(returned);
    state.hasMore = Boolean(pagination.hasMore) && returned > 0;
    state.total = Math.max(state.total || 0, total, state.allReviews.length);
    return added;
  }

  function createPaginationState(payload) {
    var state = {
      allReviews: [],
      seenReviewIds: {},
      firstPageCount: 0,
      visibleCount: 0,
      nextOffset: 0,
      hasMore: false,
      total: 0,
      loading: false,
      error: false
    };

    appendReviewPage(state, payload, 0);
    state.firstPageCount = state.allReviews.length;
    state.visibleCount = state.firstPageCount;
    return state;
  }

  function clampRating(value) {
    return Math.min(5, Math.max(0, numberOrZero(value)));
  }

  function element(tagName, className, text) {
    var node = document.createElement(tagName);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function createStars(rating, className) {
    var safeRating = clampRating(rating);
    var stars = element('span', 'storefront-reviews__stars' + (className ? ' ' + className : ''));
    stars.setAttribute('role', 'img');
    stars.setAttribute('aria-label', safeRating.toFixed(1) + ' out of 5 stars');

    for (var index = 0; index < 5; index += 1) {
      var fill = Math.min(100, Math.max(0, (safeRating - index) * 100));
      var star = element('span', 'storefront-reviews__star', '\u2605');
      star.setAttribute('aria-hidden', 'true');
      star.style.setProperty('--star-fill', fill + '%');
      stars.appendChild(star);
    }

    return stars;
  }

  function createSortControl(selectedSort, onSortChange) {
    var wrapper = element('span', 'storefront-reviews__sort-control');
    var select = element('select', 'storefront-reviews__sort-select');
    var options = [
      { value: 'featured', label: 'Most Relevant' },
      { value: 'newest', label: 'Newest' },
      { value: 'rating', label: 'Highest Rated' }
    ];

    select.setAttribute('aria-label', 'Sort reviews');
    options.forEach(function (optionConfig) {
      var option = element('option', '', optionConfig.label);
      option.value = optionConfig.value;
      option.selected = optionConfig.value === supportedSort(selectedSort);
      select.appendChild(option);
    });
    select.addEventListener('change', function () {
      onSortChange(supportedSort(select.value));
    });
    wrapper.appendChild(select);
    return wrapper;
  }

  function createSummary(payload, selectedSort, onSortChange) {
    var summary = payload.summary || {};
    var average = clampRating(summary.averageRating);
    var wrapper = element('div', 'storefront-reviews__summary-grid');
    var aggregate = element('div', 'storefront-reviews__aggregate');
    var averageNode = element('strong', 'storefront-reviews__average', average.toFixed(1));

    aggregate.appendChild(createStars(average, 'storefront-reviews__stars--large'));
    aggregate.appendChild(averageNode);
    wrapper.appendChild(aggregate);
    wrapper.appendChild(createSortControl(selectedSort, onSortChange));
    return wrapper;
  }

  function formatDate(value) {
    if (!value) return '';
    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';

    try {
      return new Intl.DateTimeFormat(
        document.documentElement.lang || 'en',
        { year: 'numeric', month: 'short', day: '2-digit' }
      ).format(date);
    } catch (error) {
      return date.toLocaleDateString();
    }
  }

  function reviewerDisplayName(review) {
    var displayName = review && review.reviewer && review.reviewer.displayName;
    return typeof displayName === 'string' && displayName.trim()
      ? displayName.trim()
      : 'Verified customer';
  }

  function safePublicUrl(value) {
    if (typeof value !== 'string' || !value.trim()) return '';

    var url = value.trim();
    if (/^\/(?!\/)/.test(url)) return url;

    try {
      return new URL(url).protocol === 'https:' ? url : '';
    } catch (error) {
      return '';
    }
  }

  function originalProductUrl(review) {
    return safePublicUrl(review && review.product && review.product.url);
  }

  function originalProductImageUrl(review) {
    return safePublicUrl(review && review.product && review.product.imageUrl);
  }

  function originalProductTitle(review) {
    var product = review && review.product;
    return product && typeof product.title === 'string' ? product.title.trim() : '';
  }

  function reviewHeadline(review) {
    var suppliedTitle = review && typeof review.title === 'string'
      ? review.title.trim()
      : '';
    if (suppliedTitle) return suppliedTitle;

    var body = review && typeof review.body === 'string'
      ? review.body.replace(/\s+/g, ' ').trim()
      : '';
    if (!body) return '';

    var sentenceMatch = body.match(/^.*?[.!?](?=\s|$)/);
    var headline = sentenceMatch ? sentenceMatch[0] : body;
    var maximumLength = 90;

    if (headline.length <= maximumLength) return headline;

    var shortened = headline.slice(0, maximumLength - 1);
    var finalSpace = shortened.lastIndexOf(' ');
    if (finalSpace > maximumLength * 0.6) {
      shortened = shortened.slice(0, finalSpace);
    }
    return shortened.replace(/[.,;:!?-]+$/, '') + '\u2026';
  }

  function createOriginalProductTitle(review) {
    var title = originalProductTitle(review);
    var productUrl = originalProductUrl(review);
    if (!title) return null;

    var titleNode = element(
      productUrl ? 'a' : 'div',
      'storefront-reviews__product-title' + (productUrl ? ' storefront-reviews__product-link' : ''),
      title
    );
    if (productUrl) titleNode.href = productUrl;
    return titleNode;
  }

  function createOriginalProductImage(review) {
    var imageUrl = originalProductImageUrl(review);
    var productUrl = originalProductUrl(review);
    var title = originalProductTitle(review);
    if (!imageUrl) return null;

    var imageWrapper = element(
      productUrl ? 'a' : 'div',
      'storefront-reviews__product-image-wrap' + (productUrl ? ' storefront-reviews__product-link' : '')
    );
    var image = element('img', 'storefront-reviews__product-image');

    if (productUrl) imageWrapper.href = productUrl;
    image.src = imageUrl;
    image.alt = title || 'Reviewed product';
    image.loading = 'lazy';
    image.decoding = 'async';
    image.width = 64;
    image.height = 64;
    image.setAttribute('fetchpriority', 'low');
    image.addEventListener('error', function () {
      if (imageWrapper.parentNode) imageWrapper.parentNode.removeChild(imageWrapper);
    });
    imageWrapper.appendChild(image);
    return imageWrapper;
  }

  function createOriginalProductReference(review) {
    var productTitle = createOriginalProductTitle(review);
    var productImage = createOriginalProductImage(review);
    if (!productTitle && !productImage) return null;

    var reference = element('div', 'storefront-reviews__product');
    if (productImage) reference.appendChild(productImage);

    if (productTitle) {
      var details = element('div', 'storefront-reviews__product-details');
      details.appendChild(element('span', 'storefront-reviews__product-label', 'Product reviewed:'));
      details.appendChild(productTitle);
      reference.appendChild(details);
    }
    return reference;
  }

  function createReview(review) {
    var article = element('article', 'storefront-reviews__review');
    var header = element('div', 'storefront-reviews__review-header');
    var main = element('div', 'storefront-reviews__review-main');
    var rating = clampRating(review.rating);
    var date = formatDate(review.submittedAt);
    var author = reviewerDisplayName(review);

    header.appendChild(element('strong', 'storefront-reviews__author', 'Reviewed by ' + author));

    if (date) {
      var time = element('time', 'storefront-reviews__date', date);
      time.dateTime = review.submittedAt;
      header.appendChild(time);
    }

    article.appendChild(header);
    main.appendChild(createStars(rating, 'storefront-reviews__stars--review'));

    var headline = reviewHeadline(review);
    if (headline) {
      main.appendChild(element('h3', 'storefront-reviews__review-title', headline));
    }
    if (review.body) {
      main.appendChild(element('p', 'storefront-reviews__body', review.body));
    }

    var productReference = createOriginalProductReference(review);
    if (productReference) main.appendChild(productReference);

    article.appendChild(main);
    return article;
  }

  function renderInlineRating(section, summary) {
    var average = clampRating(summary && summary.averageRating);
    var total = numberOrZero(summary && summary.total);
    if (!average || !total) return;

    var ownerDocument = section.ownerDocument || document;
    var anchors = ownerDocument.querySelectorAll('[data-storefront-rating-anchor]');
    var titles = ownerDocument.querySelectorAll(
      '.product_page_template h1.tt-title, ' +
      '.product_page_template .tt-product-single-info > .tt-title'
    );
    var targets = anchors.length ? anchors : titles;

    Array.prototype.forEach.call(
      ownerDocument.querySelectorAll('[data-storefront-inline-rating]'),
      function (existing) { existing.parentNode.removeChild(existing); }
    );

    Array.prototype.forEach.call(targets, function (target) {
      var link = element('a', 'storefront-reviews-inline');
      link.href = '#' + section.id;
      link.setAttribute('data-storefront-inline-rating', '');
      link.setAttribute('aria-label', 'Read ' + total + (total === 1 ? ' review' : ' reviews'));
      link.appendChild(createStars(average, 'storefront-reviews__stars--inline'));
      link.appendChild(element('strong', 'storefront-reviews-inline__average', average.toFixed(1)));
      link.appendChild(element(
        'span',
        'storefront-reviews-inline__count',
        '(' + total + (total === 1 ? ' REVIEW)' : ' REVIEWS)')
      ));
      if (target.hasAttribute('data-storefront-rating-anchor')) {
        target.appendChild(link);
      } else {
        target.insertAdjacentElement('afterend', link);
      }
    });

    Array.prototype.forEach.call(
      ownerDocument.querySelectorAll('.product_page_template .tt-review'),
      function (legacyReview) {
        legacyReview.setAttribute('data-storefront-reviews-replaced', '');
      }
    );
  }

  function setLoading(section) {
    var loading = section.querySelector('[data-reviews-loading]');
    var content = section.querySelector('[data-reviews-content]');
    section.hidden = false;
    section.setAttribute('data-state', resolveReviewState('loading'));
    loading.hidden = false;
    loading.setAttribute('aria-busy', 'true');
    content.hidden = true;
  }

  function hideSection(section) {
    section.hidden = true;
    section.setAttribute('data-state', 'hidden');
    var loading = section.querySelector('[data-reviews-loading]');
    loading.setAttribute('aria-busy', 'false');
  }

  function renderVisibleReviews(section, paginationState) {
    var reviewsNode = section.querySelector('[data-reviews-list]');
    reviewsNode.textContent = '';
    paginationState.allReviews.slice(0, paginationState.visibleCount).forEach(function (review) {
      reviewsNode.appendChild(createReview(review));
    });
  }

  function reviewsRemaining(paginationState) {
    var cached = Math.max(0, paginationState.allReviews.length - paginationState.visibleCount);
    return cached > 0 || paginationState.hasMore;
  }

  function nextPageSize(paginationState) {
    var cached = Math.max(0, paginationState.allReviews.length - paginationState.visibleCount);
    if (cached > 0) return Math.min(DEFAULT_LIMIT, cached);

    var remaining = Math.max(0, paginationState.total - paginationState.visibleCount);
    return remaining > 0 ? Math.min(DEFAULT_LIMIT, remaining) : DEFAULT_LIMIT;
  }

  function updatePagination(section, paginationState) {
    var paginationNode = section.querySelector('[data-reviews-pagination]');
    if (!paginationNode || !paginationState) return;

    var statusNode = section.querySelector('[data-reviews-pagination-status]');
    var progressNode = section.querySelector('[data-reviews-progress]');
    var progressBar = section.querySelector('[data-reviews-progress-bar]');
    var loadMoreButton = section.querySelector('[data-reviews-load-more]');
    var collapseButton = section.querySelector('[data-reviews-collapse]');
    var errorNode = section.querySelector('[data-reviews-pagination-error]');
    var countNode = section.querySelector('[data-reviews-count]');
    var shown = paginationState.visibleCount;
    var total = Math.max(paginationState.total, shown);
    var canLoadMore = reviewsRemaining(paginationState);
    var expanded = shown > paginationState.firstPageCount;
    var showFinishedState = expanded && !canLoadMore && !paginationState.error;
    var progress = total > 0 ? Math.min(100, Math.round((shown / total) * 100)) : 0;

    paginationNode.hidden = !(canLoadMore || expanded || paginationState.error);
    countNode.textContent = String(total);
    statusNode.textContent = 'Showing ' + shown + ' of ' + total + ' reviews';
    progressNode.setAttribute('aria-valuenow', String(shown));
    progressNode.setAttribute('aria-valuemax', String(total));
    progressBar.style.width = progress + '%';

    loadMoreButton.hidden = paginationState.error;
    loadMoreButton.disabled = paginationState.loading || showFinishedState;
    loadMoreButton.setAttribute('aria-busy', paginationState.loading ? 'true' : 'false');
    loadMoreButton.textContent = paginationState.loading
      ? 'Loading reviews…'
      : showFinishedState
        ? 'All reviews loaded'
        : 'Show ' + nextPageSize(paginationState) + ' more reviews';

    collapseButton.hidden = !expanded;
    errorNode.hidden = !paginationState.error;
  }

  function announcePagination(section, message) {
    var announcement = section.querySelector('[data-reviews-announcement]');
    if (!announcement) return;
    announcement.textContent = '';
    setTimeout(function () {
      announcement.textContent = message;
    }, 0);
  }

  function renderResponse(section, payload, selectedSort, onSortChange, paginationState) {
    if (resolveReviewState('success', payload) !== 'ready') {
      hideSection(section);
      return;
    }

    var summaryNode = section.querySelector('[data-reviews-summary]');
    var countNode = section.querySelector('[data-reviews-count]');
    var loading = section.querySelector('[data-reviews-loading]');
    var content = section.querySelector('[data-reviews-content]');
    var total = numberOrZero(payload.summary && payload.summary.total) || payload.reviews.length;

    summaryNode.textContent = '';
    summaryNode.appendChild(createSummary(payload, selectedSort, onSortChange));
    renderVisibleReviews(section, paginationState);
    updatePagination(section, paginationState);
    if (payload.summary) renderInlineRating(section, payload.summary);
    countNode.textContent = String(total);
    loading.hidden = true;
    loading.setAttribute('aria-busy', 'false');
    content.hidden = false;
    section.hidden = false;
    section.setAttribute('data-state', 'ready');
  }

  function parseConfig(configNode) {
    try {
      return JSON.parse(configNode.textContent);
    } catch (error) {
      return null;
    }
  }

  function positionReviewsAfterFeatures(section) {
    if (!section || !section.parentNode || !section.parentNode.querySelectorAll) {
      return false;
    }

    var parent = section.parentNode;
    var candidates = parent.querySelectorAll('.container-indent.features');
    var featureSection = null;

    Array.prototype.some.call(candidates, function (candidate) {
      if (candidate.parentNode !== parent) return false;
      featureSection = candidate;
      return true;
    });

    if (!featureSection || featureSection.nextSibling === section) {
      return false;
    }

    parent.insertBefore(section, featureSection.nextSibling);
    return true;
  }

  function variantIdFromEvent(event) {
    if (event && event.detail) {
      var detailVariant = event.detail.variant || event.detail;
      if (detailVariant && detailVariant.id) return detailVariant.id;
    }

    var target = event && event.target;
    if (target && target.name === 'id') return target.value;
    return null;
  }

  function createController(section, config) {
    var activeGroup = '';
    var activeRequestKey = '';
    var activeSort = DEFAULT_SORT;
    var currentVariantId = config.product.selectedVariantId;
    var paginationState = null;
    var requestVersion = 0;
    function showForVariant(variantId, requestedSort) {
      currentVariantId = variantId == null ? currentVariantId : variantId;
      activeSort = supportedSort(requestedSort || activeSort);
      var classification = classifyProduct(config.product, currentVariantId);

      if (!classification.group) {
        activeGroup = '';
        activeRequestKey = '';
        paginationState = null;
        requestVersion += 1;
        hideSection(section);
        if (config.developmentMode && typeof console !== 'undefined') {
          console.info('[Storefront reviews] Hidden: ' + classification.reason + '.');
        }
        return Promise.resolve(null);
      }

      var nextRequestKey = classification.group + '|' + activeSort;
      if (activeRequestKey === nextRequestKey) {
        return Promise.resolve(null);
      }

      activeGroup = classification.group;
      activeRequestKey = nextRequestKey;
      requestVersion += 1;
      var currentRequestVersion = requestVersion;
      paginationState = null;
      setLoading(section);

      return loadReviews(classification.group, config.apiUrl, null, null, activeSort, 0).then(function (payload) {
        if (currentRequestVersion !== requestVersion) return null;
        paginationState = createPaginationState(payload);
        renderResponse(section, payload, activeSort, function (nextSort) {
          showForVariant(currentVariantId, nextSort);
        }, paginationState);
        return payload;
      }).catch(function () {
        if (currentRequestVersion !== requestVersion) return null;
        activeRequestKey = '';
        paginationState = null;
        hideSection(section);
        if (typeof console !== 'undefined') {
          console.warn('[Storefront reviews] Request failed for ' + classification.group + '.');
        }
        return null;
      });
    }

    function loadMoreReviews() {
      if (!paginationState || paginationState.loading || paginationState.error) {
        return Promise.resolve(null);
      }

      var cachedRemaining = paginationState.allReviews.length - paginationState.visibleCount;
      if (cachedRemaining > 0) {
        var revealCount = Math.min(DEFAULT_LIMIT, cachedRemaining);
        paginationState.visibleCount += revealCount;
        renderVisibleReviews(section, paginationState);
        updatePagination(section, paginationState);
        announcePagination(
          section,
          revealCount + ' more reviews shown. Showing ' + paginationState.visibleCount +
          ' of ' + paginationState.total + ' reviews.'
        );
        return Promise.resolve(null);
      }

      if (!paginationState.hasMore) return Promise.resolve(null);

      var currentRequestVersion = requestVersion;
      var requestedOffset = paginationState.nextOffset;
      paginationState.loading = true;
      paginationState.error = false;
      updatePagination(section, paginationState);

      return loadReviews(
        activeGroup,
        config.apiUrl,
        null,
        null,
        activeSort,
        requestedOffset
      ).then(function (payload) {
        if (currentRequestVersion !== requestVersion || !paginationState) return null;

        var added = appendReviewPage(paginationState, payload, requestedOffset);
        paginationState.visibleCount = paginationState.allReviews.length;
        paginationState.loading = false;
        paginationState.error = false;
        renderVisibleReviews(section, paginationState);
        updatePagination(section, paginationState);
        announcePagination(
          section,
          added + ' more reviews loaded. Showing ' + paginationState.visibleCount +
          ' of ' + paginationState.total + ' reviews.'
        );
        return payload;
      }).catch(function () {
        if (currentRequestVersion !== requestVersion || !paginationState) return null;
        paginationState.loading = false;
        paginationState.error = true;
        updatePagination(section, paginationState);
        if (typeof console !== 'undefined') {
          console.warn('[Storefront reviews] Additional page failed for ' + activeGroup + '.');
        }
        return null;
      });
    }

    function collapseReviews() {
      if (!paginationState || paginationState.visibleCount <= paginationState.firstPageCount) return;
      paginationState.visibleCount = paginationState.firstPageCount;
      paginationState.error = false;
      renderVisibleReviews(section, paginationState);
      updatePagination(section, paginationState);
      announcePagination(
        section,
        'Reviews collapsed. Showing ' + paginationState.visibleCount +
        ' of ' + paginationState.total + ' reviews.'
      );
    }

    function retryPagination() {
      if (!paginationState || !paginationState.error) return Promise.resolve(null);
      paginationState.error = false;
      updatePagination(section, paginationState);
      return loadMoreReviews();
    }

    function handleVariantEvent(event) {
      var variantId = variantIdFromEvent(event);
      if (variantId == null) return;

      var isKnownVariant = (config.product.variants || []).some(function (variant) {
        return String(variant.id) === String(variantId);
      });
      if (isKnownVariant) showForVariant(variantId);
    }

    document.addEventListener('change', handleVariantEvent);
    document.addEventListener('variant:change', handleVariantEvent);
    document.addEventListener('variant:changed', handleVariantEvent);
    document.addEventListener('product:variant-change', handleVariantEvent);

    var loadMoreButton = section.querySelector('[data-reviews-load-more]');
    var collapseButton = section.querySelector('[data-reviews-collapse]');
    var retryButton = section.querySelector('[data-reviews-retry]');
    if (loadMoreButton) loadMoreButton.addEventListener('click', loadMoreReviews);
    if (collapseButton) collapseButton.addEventListener('click', collapseReviews);
    if (retryButton) retryButton.addEventListener('click', retryPagination);

    showForVariant(config.product.selectedVariantId);
    return {
      showForVariant: showForVariant,
      handleVariantEvent: handleVariantEvent,
      loadMoreReviews: loadMoreReviews,
      collapseReviews: collapseReviews,
      retryPagination: retryPagination
    };
  }

  function initialize() {
    var configNodes = document.querySelectorAll('[data-storefront-reviews-config]');
    Array.prototype.forEach.call(configNodes, function (configNode) {
      if (configNode.getAttribute('data-initialized') === 'true') return;
      configNode.setAttribute('data-initialized', 'true');

      var config = parseConfig(configNode);
      var section = config && document.getElementById('StorefrontReviews-' + config.product.id);
      if (!config || !section || !config.apiUrl) {
        if (section) hideSection(section);
        return;
      }

      positionReviewsAfterFeatures(section);
      createController(section, config);
    });
  }

  return {
    SUPPORTED_GROUPS: SUPPORTED_GROUPS,
    SUPPORTED_SORTS: SUPPORTED_SORTS,
    appendReviewPage: appendReviewPage,
    buildApiUrl: buildApiUrl,
    classifyProduct: classifyProduct,
    createController: createController,
    createPaginationState: createPaginationState,
    initialize: initialize,
    loadReviews: loadReviews,
    originalProductImageUrl: originalProductImageUrl,
    originalProductUrl: originalProductUrl,
    positionReviewsAfterFeatures: positionReviewsAfterFeatures,
    reviewHeadline: reviewHeadline,
    reviewerDisplayName: reviewerDisplayName,
    resolveReviewState: resolveReviewState,
    shouldFetchGroup: shouldFetchGroup,
    supportedSort: supportedSort,
    validateResponse: validateResponse
  };
});
